<template>
  <div id="public">
    <div class="loading" v-if="loading">
      <div class="lds-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <span>{{$i18n.t('modal.loading')}}</span>
    </div>
    <div class="container-grid" v-if="resultado != undefined && resultado.length > 0">
      <div class="box card" v-for="link in resultado" :key="link._id">
        <img
          v-if="link.content_type && link.content_type.includes('image')"
          :src="`${link.url}`"
          class="card-img-top pointer"
          @click="open(`${link.url}`,link.bucket._id)"
        />
        <img
          v-if="link.filename.toLowerCase().includes('.pdf')"
          src="../img/pdf.png"
          class="card-img-top pointer"
          @click="open(`${link.url}`,link.bucket._id)"
          alt
        />
        <img
          v-if="link.content_type && link.filename.toLowerCase().includes('.xls')||link.filename.toLowerCase().includes('.xlsx')||link.filename.toLowerCase().includes('.xlt')"
          src="../img/xls.png"
          class="card-img-top pointer"
          @click="open(`${link.url}`,link.bucket._id)"
          alt
        />
        <audio v-if="link.content_type && link.content_type.includes('audio')" controls="controls">
          <source :src="`${link.url}`" />
        </audio>
        <img v-if="noSoportado(link)" src="../img/noSoporte.png" class="previewImagen" />
        <div class="card-body">
          <p class="card-text">{{link.desc}}</p>
          <h6 class="card-subtitle mb-2 text-muted">{{link.filename}}</h6>
          <button
            v-on:click="descargarRecurso(link._id,link.filename)"
            class="btn btn-info card-link"
            :title="$i18n.t('articulo.button.download')"
          >
            <i class="fas fa-file-download"></i>
          </button>
        </div>
      </div>
    </div>
    <div
      class="card"
      style="border:0px !important"
      v-if="(resultado == undefined || resultado.length == 0) && !loading"
    >
      <div class="card-body">
        <div class="card-text">{{$i18n.t('articulo.empty')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "publico",
  data() {
    return {
      ids: [],
      etiquetas: [],
      resultado: [],
      loading: true
    };
  },
  async mounted() {
    this.ids = this.$route.query.ids;
    this.etiquetas = this.$route.query.etiquetas;
    this.resultado = await new Promise((res) => {
      this.axios
        .get(`./api/public?ids=${this.ids}&labels=${this.etiquetas}`)
        .then(p => {
          this.loading = false;
          res(p.data);
        });
    });

    for(let i=0; i < this.resultado.length; i++) {

      this.open(this.resultado[i].url,this.resultado[i].bucket._id);

    }


  },
  methods: {
    descargarRecurso(id, filename) {
      this.axios
        .get(this.$store.getters.ws.api_recursos + "/resources/" + id, {
          responseType: "blob"
        })
        .then(response => {
          let link = document.createElement("a");
          let url = window.URL.createObjectURL(new Blob([response.data]));
          link.href = url;
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        });
    },
    open(url, bucket) {

      //MODIFICADO2
      //let dirurl = '5e454a735b45541ffc4c3532|2,5e46eb7a9693cb30aada0f9e,5e454a735b45541ffc4c3532';


      let dirurl = this.$route.query.ids;

      let arraydir = dirurl.split(',');

      for(let i=0; i < arraydir.length; i++) {

        let longpipe = arraydir[i].indexOf("|");

        if(longpipe != -1){

          let idbucket = arraydir[i].substring(arraydir[i],longpipe);

          if(bucket == idbucket){

            let cantidad_pipe = arraydir[i].substring((longpipe+1),arraydir[i].length);

            for(let i=0; i< cantidad_pipe; i++){

              window.open(url, "_blank");

            }

            break;

          }

        }else{

          if(bucket == arraydir[i]){

            let cantidad_pipe = 1;

            for(let i=0; i< cantidad_pipe; i++){

              window.open(url, "_blank");

            }

            break;
          }

        }


      }





    },
    noSoportado(recurso) {
      if (
        recurso.filename &&
        recurso.content_type != null &&
        recurso.content_type
      )
        return !(
          recurso.filename.toLowerCase().includes(".xls") ||
          recurso.filename.toLowerCase().includes(".xlsx") ||
          recurso.filename.toLowerCase().includes(".xlt") ||
          recurso.filename.toLowerCase().includes(".pdf") ||
          recurso.content_type.includes("video") ||
          recurso.content_type.includes("image") ||
          recurso.content_type.includes("audio")
        );
      else return recurso.content_type == null;
    }
  }
};
</script>
<style>
</style>